export const iconFontAwesomeMaritimeAnchor = (
	<i className="fa-solid fa-anchor"></i>
);
